import { render, staticRenderFns } from "./GroupRole.vue?vue&type=template&id=172055ec&scoped=true"
import script from "./GroupRole.vue?vue&type=script&lang=js"
export * from "./GroupRole.vue?vue&type=script&lang=js"
import style0 from "./GroupRole.vue?vue&type=style&index=0&id=172055ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172055ec",
  null
  
)

export default component.exports